import { clientVariableLineConstants } from "../constants/clientVariableLine.constants";

export function clientVariableLine(state = {}, action) {
  switch (action.type) {
    case clientVariableLineConstants.GET_REQUEST:
    case clientVariableLineConstants.CREATE_REQUEST:
    case clientVariableLineConstants.UPDATE_REQUEST:
    case clientVariableLineConstants.DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        request: action.payload,
        error: false,
        success: false,
      };
    case clientVariableLineConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        paginatedResult: action.payload,
      };
    case clientVariableLineConstants.CREATE_SUCCESS:
    case clientVariableLineConstants.UPDATE_SUCCESS:
    case clientVariableLineConstants.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        // Only CREATE_SUCCESS's action creator passes a payload -- undefined here for
        // UPDATE/DELETE, which also conveniently clears out a stale value from an earlier create.
        createdLine: action.payload,
      };
    case clientVariableLineConstants.CREATE_FAILURE:
    case clientVariableLineConstants.GET_FAILURE:
    case clientVariableLineConstants.DELETE_FAILURE:
    case clientVariableLineConstants.UPDATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
}
